import { render, staticRenderFns } from "./ImpressaoTermica.vue?vue&type=template&id=83c9d4d4&scoped=true&"
import script from "./ImpressaoTermica.vue?vue&type=script&setup=true&lang=js&"
export * from "./ImpressaoTermica.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ImpressaoTermica.vue?vue&type=style&index=0&id=83c9d4d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c9d4d4",
  null
  
)

export default component.exports